
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { SubscriptionWInstance }  from 'src/app/portal/account-console-test/subscription-management/subscription-management.component';
import { MatTableDataSource } from '@angular/material/table';
import { ContractDetails } from 'src/app/model/contractDetails';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { OperationResult } from '@tb/auth';

@Component({
    selector: 'ms-multicompany-section',
    templateUrl: './multicompany-section.component.html',
    styleUrls: ['./multicompany-section.component.scss'],
})
export class MulticompanySectionComponent implements OnInit {
  subscriptionFound: boolean = true;
  noItems: boolean = false;
  multicompanyNr: number;
  public subscriptionT: SubscriptionWInstance[];
  displayedColumnsSubscription: string[] = ['CompanyName','SubscriptionKey'];
  @Input() currentRow: ContractDetails;
  dataSourceSubscription: MatTableDataSource<SubscriptionWInstance>;
  constructor(
    private subscriptionService: SubscriptionService,
    private workFlow: WorkFlowService,
    private variable: TranslatedVariables,
    public configurationService: ConfigurationService,
  ) { }

  async ngOnInit() {
    this.noItems = true;
    this.multicompanyNr = await this.checkMultiNr();
    await this.loadInfo();
  }

  public async checkMultiNr() {
    //questa funzione mi ritorna il numero degli articoli di tipo MULT nell'attivazione master
    let opRes: OperationResult = await this.configurationService.getmulticompanynr(
        this.currentRow.SubscriptionKey,
        this.currentRow.ProductID,
        this.currentRow.CodiceTitolare,
        this.currentRow.CodiceCliente,
        this.currentRow.Matricola,
        "infinity"
    );

    if (!opRes.Result) return -1;

    let multiCount: number = opRes.Content as number;
    return multiCount;
}


async loadInfo() {
  this.subscriptionService.getSlaveSubscription(this.currentRow.SubscriptionKey).subscribe(
      (res) => {
          const opRes: boolean = res['Result'];
          if (!opRes) {
              this.workFlow.showMessage(this.variable.errorTitle, res['Message']);
              this.subscriptionFound = false;
              return;
          } else if (res['Content'].length === 0) {
              this.subscriptionFound = false;
              return;
          } else {
              this.subscriptionFound = true;
              this.subscriptionT = res['Content'];
              this.dataSourceSubscription = new MatTableDataSource<SubscriptionWInstance>(this.subscriptionT);
          }
      },
      (err) => {
          this.workFlow.showMessage(this.variable.errorTitle, err.message);
      }
  );

}

}
